import CbForm from './src/form.vue';

CbForm.install = function(Vue) {
  Vue.component(CbForm.name, CbForm);
};

export default CbForm;
